import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { DeviceContentProvider } from 'console/shared/contexts/device';
import { VehicleDeviceProvider } from 'console/shared/contexts/vehicle-device';
import { VehicleTabContent } from './content';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const VehicleTab = memo(function VehicleTab(props) {
    const { r_device: device } = props;
    return (_jsx(DeviceContentProvider, { device: device, tab_key: DefaultTabKey.vehicle_tab, children: _jsx(VehicleDeviceProvider, { children: _jsx(VehicleTabContent, {}) }) }));
});
